import React, { createContext, useState } from "react";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(
    JSON.parse(localStorage.getItem("usuario")) || null
  );

  const guardarUsuarioEnLocalStorage = (usuario) => {
    localStorage.setItem("usuario", JSON.stringify(usuario));
  };

  const actualizarUsuario = (actualizar) => {
    guardarUsuarioEnLocalStorage(actualizar);
    setUsuario(actualizar);
  };

  const url =
    "https://oocqaprpcxowckkspozr.supabase.co/storage/v1/object/public/fotos_perfil/perfil/";

  const [click, setClick] = useState(false);
  const [fotoSubida, setFotoSubida] = useState(false);

  return (
    <DataContext.Provider
      value={{
        usuario,
        actualizarUsuario,
        url,
        click,
        setClick,
        fotoSubida,
        setFotoSubida,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
